<!--
create by melody on 2018/11/1
description:值集配置页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
		<template v-if="!isShowEdit">
			<div class="search-container hdp-w-100">
				<div class="hdp-uf hdp-w-100">
					<div class="hdp-uf hdp-uf-vc">{{$t('m.keyName')}}：</div>
					<el-input v-model="searchParam.keyName" :placeholder="$t('m.valueSetSearch')" style="width:25%;margin-left:10px;margin-right:5%;" clearable></el-input>
					<!-- <el-button type="primary" icon="el-icon-search" style="margin-left:5%;" @click="getDemoList()"> 查 询</el-button> -->
                    <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
				</div>
			</div>
			<div class="table-container">
				<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
				<!-- <el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> 删除值集 </el-button> -->
				<el-table
					ref="multipleTable"
					:data="tableData"
					stripe
					tooltip-effect="dark"
					style="width: 100%;margin: 24px 0"
					@select="handleSelect"
	                @select-all="handleSelect"
					>
					<!-- <el-table-column
						type="selection"
						width="35">
					</el-table-column> -->
					<el-table-column
						type="index"
						label="#">
					</el-table-column>
					<el-table-column
						:label="$t('m.valuesetName')">
                        <template  slot-scope="scope">
                            <span class="span-style" @click="handleEdit(scope.row)">{{scope.row.valuesetName}}</span>
                        </template>
					</el-table-column>
					<el-table-column
						prop="valuesetCode"
						:label="$t('m.valuesetCode')">
					</el-table-column>
					<el-table-column
						prop="createTime"
						:label="$t('m.createTime')">
					</el-table-column>
					<el-table-column
						prop="enableFlag"
						:label="$t('m.enableFlag')">
						<template slot-scope="scope">
	                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
	                    </template>
					</el-table-column>
                    <el-table-column
                        prop="fixedFlag"
                        :label="$t('m.fixedFlag')">
                        <template slot-scope="scope">
                            <span>{{scope.row.fixedFlag == true ? 'Yes' : 'No'}}</span>
                        </template>
                    </el-table-column>
					<el-table-column
						:label="$t('m.operation')"
						align="right" width="150">
						<template slot-scope="scope" v-if="scope.row.fixedFlag">
							<el-button  icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button>
							<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single',scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
			</div>
		</template>
		<template v-if="isShowEdit">
			<div class="table-container">
				<p>
					<el-button type="text" icon="el-icon-arrow-left" @click="goBack">{{$t('m.back')}}</el-button>
				</p>
				<div class="" style="margin-top:30px;">
					<el-button v-if="fixedFlag" type="primary" icon="el-icon-plus" plain @click="handleClick('addLine')"> {{$t('m.add')}} </el-button>
					<!-- <el-button type="info" icon="el-icon-delete" plain @click="handleDelete2('batch')"> 删除值 </el-button> -->
				</div>

				<div class="hdp-uf psc-bg-info2 psc-font-4" style="margin-top:24px;padding:10px;">{{ valuesetNameFlag }}</div>
				<el-table
					ref="multipleTable"
					:data="tableData2"
					stripe
					tooltip-effect="dark"
					style="width: 100%;margin: 24px 0"
					@select="handleSelect2"
	                @select-all="handleSelect2"
					>
					<el-table-column
						type="selection"
						width="35">
					</el-table-column>
					<el-table-column
						type="index"
						label="#">
					</el-table-column>
					<el-table-column
						prop="valuesetLineContent"
						:label="$t('m.valuesetLineContent')">
					</el-table-column>
					<el-table-column
						prop="valuesetLineCode"
						:label="$t('m.valuesetLineCode')">
					</el-table-column>
                    <el-table-column
                        prop="valuesetLineProperty"
                        :label="$t('m.valuesetLineProperty')">
                    </el-table-column>
					<el-table-column
						prop="enableFlag"
						:label="$t('m.enableFlag')">
						<template slot-scope="scope">
	                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
	                    </template>
					</el-table-column>
					<el-table-column
                        v-if="fixedFlag"
						:label="$t('m.operation')"
						align="right" width="150">
						<template slot-scope="scope">
							<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modifyLine', scope.row)"></el-button>
							<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete2('single', scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
                <lap-pagination :total="total2" :searchParam="searchParam2" @successMethod="getDemoList2()"></lap-pagination>
			</div>
		</template>
		<!-- Add Form -->
		<el-dialog 
			:title="operateType=='add'? $t('m.add') :operateType=='addLine'? $t('m.addLine'): $t('m.modify')" 
			:visible.sync="dialogVisible"
			v-if="dialogVisible">
			<div class="dialog-content">
                <el-form v-if="operateType=='add'||operateType=='modify'" ref="form" :model="form" :rules="rules" label-width="180px">
                    <el-form-item :label="$t('m.valuesetName')" prop="valuesetName" style="width: 420px">
                        <el-input v-model.trim="form.valuesetName" :maxlength="$inputLengthObj.maxLength1"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.valuesetCode')" prop="valuesetCode" style="width: 420px">
                        <el-input v-model.trim="form.valuesetCode"  :maxlength="$inputLengthObj.maxLength1"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 420px;">
                        <el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('m.fixedFlag')" prop="fixedFlag" style="width: 420px;">
                        <el-radio-group  v-model="form.fixedFlag">
                            <el-radio :label="true" checked>Yes</el-radio>
                            <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <el-form v-else ref="lineForm" :model="lineForm" :rules="lineRules" label-width="180px">
                    <el-form-item :label="$t('m.valuesetLineContent')" prop="valuesetLineContent" style="width: 420px">
                        <el-input v-model.trim="lineForm.valuesetLineContent" :maxlength="$inputLengthObj.maxLength3"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.valuesetLineCode')" prop="valuesetLineCode" style="width: 420px">
                        <el-input v-model.trim="lineForm.valuesetLineCode" :maxlength="$inputLengthObj.maxLength1"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.valuesetLineProperty')" style="width: 420px">
                        <el-input v-model.trim="lineForm.valuesetLineProperty" :maxlength="$inputLengthObj.maxLength1"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 420px;">
                        <el-radio-group  v-model="lineForm.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.VALUE_SET')
			},
			searchParam: {      //查询参数
                keyName: '',
                pageSize: 10,
                pageNum: 1,
            },
            searchParam2: {      //查询参数
               	valuesetId: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {     //弹框内容
                valuesetId: '',
                valuesetName: '',
                valuesetCode: '',
                enableFlag: true,
                fixedFlag: true
            },
            lineForm: {     //弹框内容
                valuesetId: '',
                valuesetLineId: '',
                valuesetLineContent: '',
                valuesetLineCode: '',
                valuesetLineProperty: '',
                enableFlag: true
            },
            rules: this.$ruleApi.getRule('valueSet'),
            lineRules: this.$ruleApi.getRule('valueSetLine'),
            tableData: [],
            tableData2: [],
            total: 0,
            total2: 0,
			deleteDemoIdArr: [],
			deleteDemoLineIdArr: [],
			isShowEdit:false,
			operateType: '',    //操作类型 add新增 modify修改 view查看
			dialogVisible: false,
			valuesetNameFlag: '',
			valuesetIdFlag: '',
            fixedFlag: false,
            addDisable: false
		}
	},
	methods: {
		getDemoList() {
			this.$commonFunc.commonRequest('get', '/configValueset/list/condition', 'getValueSetList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
		},
		getDemoList2() {
			this.$commonFunc.commonRequest('get', '/configValuesetLine/list/valuesetId', 'getValueSetLineList', this.searchParam2)
            .then(res=>{
                this.tableData2 = res.obj.list
                this.total2 = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
		},
		addDemo() {
            this.$commonFunc.commonRequest('post', '/configValueset/added', 'addValueSet', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/configValueset/modified', 'modifyValueSet', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemoLine() {
            this.$commonFunc.commonRequest('post', '/configValuesetLine/added', 'addValueSetLine', this.lineForm)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList2()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemoLine() {
            this.$commonFunc.commonRequest('post', '/configValuesetLine/modified', 'modifyValueSetLine', this.lineForm)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList2()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            this.dialogVisible = true
           	if(type == 'add') {
           		this.form = {     //弹框内容
	                valuesetId: '',
	                valuesetName: '',
	                valuesetCode: '',
	                enableFlag: true,
                    fixedFlag: true
	            }
           	} else if(type=='addLine') {
	           	this.lineForm = {     //弹框内容
	                valuesetId: this.valuesetIdFlag,
	                valuesetLineId: '',
	                valuesetLineContent: '',
	                valuesetLineCode: '',
	                enableFlag: true
	            }
           	} else if(type=='modify') {
                this.form = JSON.parse(JSON.stringify(row))
            } else {
           		this.lineForm["valuesetId"] = row.valuesetId
           		this.lineForm["valuesetLineId"] = row.valuesetLineId
           		this.lineForm["valuesetLineContent"] = row.valuesetLineContent
           		this.lineForm["valuesetLineCode"] = row.valuesetLineCode
                this.lineForm["valuesetLineProperty"] = row.valuesetLineProperty
           		this.lineForm["enableFlag"] = row.enableFlag
           	}
        },
        //弹框保存操作
        haddleSave(type) {
        	if(type == 'add' || type == 'modify') {
        		this.$refs['form'].validate((valid) => {
	                if (valid) {
                        if(type == 'add') {
                            this.addDemo()
                            this.addDisable = true
                        } else {
                            this.modifyDemo()
                        }
	                } else {
	                    return false;
	                }
	            });
        	} else {
        		this.$refs['lineForm'].validate((valid) => {
	                if (valid) {
	                    if(type == 'addLine') {
	                    	this.addDemoLine()
                            this.addDisable = true
	                    } else {
	                        this.modifyDemoLine()
	                    }
	                } else {
	                    return false;
	                }
	            });
        	}
        },
        handleDelete(type,row) {
            if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let valuesetIds = []
                if (type == 'single') {
                    valuesetIds = row.valuesetId
                } else {
                	valuesetIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('get', '/configValueset/deleted', 'deleteValueSet', {valuesetIds: valuesetIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'));
                    this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
        handleDelete2(type,row) {
            if( type == 'batch' && this.deleteDemoLineIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let valuesetLineIds = []
                if (type == 'single') {
                    valuesetLineIds.push(row.valuesetLineId) 
                } else {
                	valuesetLineIds = this.deleteDemoLineIdArr
                }
                this.$commonFunc.commonRequest('get', '/configValuesetLine/deleted', 'deleteValueSetLine', {valuesetLineIds: valuesetLineIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'));
                    this.deleteDemoLineIdArr = []
                	this.getDemoList2()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		handleEdit (row) {
			this.isShowEdit = true
			this.searchParam2.valuesetId = row.valuesetId
			this.valuesetIdFlag = row.valuesetId
			this.valuesetNameFlag = row.valuesetName
            this.fixedFlag = row.fixedFlag
			this.getDemoList2()
		},
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].valuesetId)
                }
            }
        },
        //处理单选
        handleSelect2(row) {
            this.deleteDemoLineIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoLineIdArr.push(row[i].valuesetLineId)
                }
            }
        },
		goBack (){
			this.isShowEdit = false
		}
	},
	mounted() {
		this.getDemoList()
	}
}
</script>
<style scoped lang="scss">
.search-container {
	background: #ffffff;
	padding: 20px;
}
.el-select {
	width: 300px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.block {
	text-align: right;
}
.span-style {
    color: #409EFF;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/ValueSet.vue